import React from 'react'

const LineSkelton = () => {
  return (
    <>
    {/* Line of Skeleton */}
    <div className="h-3 md:h-4 w-24 bg-gray-300 rounded-md mt-2 animate-pulse"></div>
    </>
  )
}

export default LineSkelton
